import makeStyles from '@mui/styles/makeStyles'
import moment from 'moment'
import { CvsAvatar } from '@components'
import { colors } from '@global/constants'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
  },
  username: {
    fontWeight: 'bold',
    fontSize: 14,
    color: colors.gray.medium,
  },
  createdAt: {
    fontWeight: 'light',
    fontSize: 12,
    lineHeight: '12px',
    color: colors.gray.medium,
  },
}))

const avatarStyles = {
  marginRight: '8px',
}

export function DiffUser({ diff }) {
  if (!diff) {
    return <></>
  }

  const formattedCreatedAt = moment(diff.commit.createdAt).format('lll')
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <CvsAvatar style={avatarStyles} user={diff.user} />
      <div>
        <div className={classes.username}>{diff.user.name}</div>
        <div className={classes.createdAt}>{formattedCreatedAt}</div>
      </div>
    </div>
  )
}
